/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DocumentGetMetadata =
  | string
  | number
  | number
  | boolean
  | Array<string>;

export type DocumentGet = {
  status: string;
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  metadata: { [k: string]: string | number | number | boolean | Array<string> };
  partition: string;
  chunkCount?: number | null | undefined;
  externalId?: string | null | undefined;
  pageCount?: number | null | undefined;
  errors: Array<string>;
};

/** @internal */
export const DocumentGetMetadata$inboundSchema: z.ZodType<
  DocumentGetMetadata,
  z.ZodTypeDef,
  unknown
> = z.union([
  z.string(),
  z.number().int(),
  z.number(),
  z.boolean(),
  z.array(z.string()),
]);
/** @internal */
export type DocumentGetMetadata$Outbound =
  | string
  | number
  | number
  | boolean
  | Array<string>;

/** @internal */
export const DocumentGetMetadata$outboundSchema: z.ZodType<
  DocumentGetMetadata$Outbound,
  z.ZodTypeDef,
  DocumentGetMetadata
> = z.union([
  z.string(),
  z.number().int(),
  z.number(),
  z.boolean(),
  z.array(z.string()),
]);

export function documentGetMetadataToJSON(
  documentGetMetadata: DocumentGetMetadata,
): string {
  return JSON.stringify(
    DocumentGetMetadata$outboundSchema.parse(documentGetMetadata),
  );
}
export function documentGetMetadataFromJSON(
  jsonString: string,
): SafeParseResult<DocumentGetMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentGetMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentGetMetadata' from JSON`,
  );
}

/** @internal */
export const DocumentGet$inboundSchema: z.ZodType<
  DocumentGet,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: z.string(),
  id: z.string(),
  created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  updated_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  name: z.string(),
  metadata: z.record(
    z.union([
      z.string(),
      z.number().int(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
    ]),
  ),
  partition: z.string(),
  chunk_count: z.nullable(z.number().int()).optional(),
  external_id: z.nullable(z.string()).optional(),
  page_count: z.nullable(z.number()).optional(),
  errors: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    "created_at": "createdAt",
    "updated_at": "updatedAt",
    "chunk_count": "chunkCount",
    "external_id": "externalId",
    "page_count": "pageCount",
  });
});
/** @internal */
export type DocumentGet$Outbound = {
  status: string;
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  metadata: { [k: string]: string | number | number | boolean | Array<string> };
  partition: string;
  chunk_count?: number | null | undefined;
  external_id?: string | null | undefined;
  page_count?: number | null | undefined;
  errors: Array<string>;
};

/** @internal */
export const DocumentGet$outboundSchema: z.ZodType<
  DocumentGet$Outbound,
  z.ZodTypeDef,
  DocumentGet
> = z.object({
  status: z.string(),
  id: z.string(),
  createdAt: z.date().transform(v => v.toISOString()),
  updatedAt: z.date().transform(v => v.toISOString()),
  name: z.string(),
  metadata: z.record(
    z.union([
      z.string(),
      z.number().int(),
      z.number(),
      z.boolean(),
      z.array(z.string()),
    ]),
  ),
  partition: z.string(),
  chunkCount: z.nullable(z.number().int()).optional(),
  externalId: z.nullable(z.string()).optional(),
  pageCount: z.nullable(z.number()).optional(),
  errors: z.array(z.string()),
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
    updatedAt: "updated_at",
    chunkCount: "chunk_count",
    externalId: "external_id",
    pageCount: "page_count",
  });
});

export function documentGetToJSON(documentGet: DocumentGet): string {
  return JSON.stringify(DocumentGet$outboundSchema.parse(documentGet));
}
export function documentGetFromJSON(
  jsonString: string,
): SafeParseResult<DocumentGet, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DocumentGet$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DocumentGet' from JSON`,
  );
}
